import React from "react";
import Navbar from "../Navbar/Navbar";
import CheckoutSearchTabs from "../Home/CheckoutSearchTabs/CheckoutSearchTabs";
import CheckoutForm from "./ChechoutForm/CheckoutForm";
import Footer from "../Footer/Footer";
import { useLocation } from "react-router-dom";

const FlightCheckout = () => {
  const location = useLocation();

  // const flight = location.state?.flight;
  // const passenger = location?.state?.passenger;
  const flightSearchParams = location?.state?.flightSearchParams;
  const flightsPreorderResult = location?.state?.flightsPreorderResult;

  return (
    <>
      <Navbar />
      <div className="layout-content flight-checkout-page">
        {/* <CheckoutSearchTabs /> */}
        <section className="flight-checkout-shell">
          <div className="container p-0">
            <div className="flight-checkout-hero">
              <div>
                <p>Secure flight checkout</p>
                <h1>Review passengers and lock in your fare.</h1>
              </div>
              <div className="flight-checkout-hero__meta">
                <span>Live fare validation</span>
                <span>Razorpay secure payment</span>
              </div>
            </div>
            <CheckoutForm
              flightSearchParams={flightSearchParams}
              flightsPreorderResult={flightsPreorderResult}
              selectedItinerary={flightsPreorderResult?.selectedItinerary}
            />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default FlightCheckout;
